var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"text--m"},[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.mock,"disable-pagination":"","dense":"","height":"160","hide-default-footer":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }